import { getCities } from '../../api/authApi'
import NavBar from '../../components/nav-bar/nav-bar'
import translate from '../../i18n'
import { setActiveCitiesAction } from '../../store/city/action'
import { Space } from 'antd'
import { useEffect } from 'react'
import { connect, ConnectedProps } from 'react-redux'
import { Outlet, useLocation } from 'react-router-dom'
import { compose } from 'redux'

const PlansContainer = (props: ConnectedProps<typeof withConnect>) => {
  const location = useLocation()

  useEffect(() => {
    getCities().then(res => {
      const { setActiveCitiesAction } = props
      setActiveCitiesAction(res)
    })
  }, [])

  const getNavBarTitle = () => {
    const pathName = location.pathname
    if (pathName.match(/^\/plans\/[0-9]+$/)) {
      return translate('navBar.viewPlanTitle')
    }
    if (pathName.match(/^\/plans\/new$/)) {
      return translate('navBar.newPlan')
    }
    if (pathName.match(/^\/plans\/[0-9]+\/edit$/)) {
      return translate('navBar.editPlan')
    }
    return translate('navBar.plansTitle')
  }

  return (
    <Space className="dashboard-wrapper" orientation="vertical">
      <NavBar title={getNavBarTitle()}></NavBar>
      <Outlet />
    </Space>
  )
}

const mapDispatchToProps = {
  setActiveCitiesAction,
}

const withConnect = connect(null, mapDispatchToProps)

export default compose(withConnect)(PlansContainer)
